export default "__VITE_ASSET__wi4ATyMc__"